/**
 * Hooks
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useToken from "../../../hooks/useToken";
import useCachedData from "../../../hooks/useCachedData";

/**
 * Utils
 */
import { fetchExtraActions } from "../../../utils/api";

/**
 * MUI Components
 */
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const ExtraActionSelectControl = ({ value, onChange }) => {
    const { t } = useTranslation();
    const { token } = useToken();
    const [localValue, setLocalValue] = useState(value);

    const abortController = new AbortController();
    const fetcher = () => fetchExtraActions(token, abortController.signal);

    const { data, loading, error } = useCachedData(
        "forestal-actions", // Cache key
        fetcher,
        { useCache: true, forceRefresh: false }
    );

    const handleLocalChange = (event) => {
        const newValue = event.target.value;
        setLocalValue(newValue);
        if (onChange) {
            onChange(newValue); // Call react-hook-form's onChange
        }
    };

    useEffect(() => {
        return () => abortController.abort(); // Clean up on unmount
    }, []);

    // Only set localValue from value on the first render
    useEffect(() => {
        setLocalValue(value);
        // console.debug('Extra action local:', localValue, 'initial:', value);
    }, [value]);

    if (loading) return <p>{t('Loading')}...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <FormControl fullWidth>
            <InputLabel id="extra-action-label">{t('Action')}</InputLabel>
            <Select
                labelId="extra-action-label"
                id="select-extra-action"
                name="selectAction"
                value={localValue}
                onChange={handleLocalChange}
                label={t('Action')}
            >
                {data.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default ExtraActionSelectControl;